import Box from 'components/Box';
import Text from 'components/Text';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import reportActions from 'features/report/services/actions';
import reportSelectors from 'features/report/services/selectors';
import moment from 'moment';
import { useEffect } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import AppointmentDatePicker from '../../components/DatePicker';
import SwitchCalendarType from '../../components/SwitchCalendarType';
import { ReportType } from '../../constants';
import PrintSummaryBill from './PrintSummaryBill';

const RevenueIncomeHeader = () => {
  const dispatch = useAppDispatch();
  const dataAppointment = reportSelectors.getParams()?.[ReportType.REVENUE];

  useEffect(() => {
    dispatch(
      reportActions.setParams({
        [ReportType.REVENUE]: {
          startTime: dataAppointment?.startTime || moment().format(DATE_FORMAT),
          endTime: dataAppointment?.endTime || moment().format(DATE_FORMAT),
        },
      })
    );
  }, []);

  return (
    <HeaderBox>
      <Box>
        <Text className='title-page'>
          Revenue Income
        </Text>
      </Box>
      <HeaderBox className='v2'>
        <SwitchCalendarType
          v2
          actions={reportActions}
          selectors={reportSelectors}
          type={ReportType.REVENUE}
          yearComparison
        />
        <AppointmentDatePicker
          v2
          size='middle'
          actions={reportActions}
          selectors={reportSelectors}
          type={ReportType.REVENUE}
        />
        <PrintSummaryBill />
      </HeaderBox>
    </HeaderBox>
  );
};

export default RevenueIncomeHeader;

const HeaderBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  &.v2 {
    .btn-print {
      .CONTENT_2 {
        color: #1d2129;
        text-align: center;
        font-family: Poppins;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }
    }
  }
`;
